import React, { useEffect, useState } from "react";
import { useUpdateUsernameMutation } from "../../Services/ticket/TicketDetail";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { Box, Button, Chip, IconButton, Tooltip } from "@mui/material";
import { useInternalNotesMutation } from "../../Services/Messages/Messages";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import InfoIcon from "@mui/icons-material/Info";
import { useCustomerNotesMutation } from "../../Services/ticket/Messages";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import axios from "axios";

interface IProps {
  data: any;
  closeStatusModal: any;
  refetch: any;
  refetchAuditTrail: any;
  selectedStatus: any;
  handleStatusUpdate: any; // Add this prop to handle status update
  refetchAuditTrailData: any;
  selectedAllStatus: any;
  storingTicketId: any;
  refetchAuditTrailForwardedData: any
}

const ChangeStatusModal = ({
  data,
  closeStatusModal,
  refetch,
  refetchAuditTrail,
  selectedStatus,
  handleStatusUpdate,
  refetchAuditTrailData,
  selectedAllStatus,
  storingTicketId,
  refetchAuditTrailForwardedData
}: IProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [files, setFiles] = useState([]);
  const [value, setValue] = useState<string>("");
  const [initialsShow, setInitialShow] = useState<boolean>(false);
  const [savingLoading, setSavingLoading] = useState<boolean>(false);
  const params = useParams();
  const uuid = params.uuid;
  const [noteType, setNoteType] = useState<"internal" | "external">("internal");
  const [updateStatus] = useUpdateUsernameMutation();
  const [trigger] = useInternalNotesMutation();
  const [customertrigger, error] = useCustomerNotesMutation();
  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const [internalNoteSaved, setInternalNoteSaved] = useState(false);
  const [externalNoteSaved, setExternalNoteSaved] = useState(false);
  const [internalNoteSavedOnce, setInternalNoteSavedOnce] = useState(false);
  const [externalNoteSavedOnce, setExternalNoteSavedOnce] = useState(false);
  const [autoSwitchToExternal, setAutoSwitchToExternal] = useState(false);
  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await updateStatus({
        id: storingTicketId ? storingTicketId : `${uuid}`,
        status_type: selectedStatus,
        status:
          selectedAllStatus.status_type === "wip" ? selectedAllStatus.id : null, // WIP
        closed_status:
          selectedAllStatus.status_type === "closed"
            ? selectedAllStatus.id
            : null, // closed
      });

      if (response.data) {
        console.log(response.data, "data");
        // Check for detail error message from backend
        if (Array.isArray(response.data.detail) && response.data.detail.length > 0) {
          toast.error(response.data.detail[0]);
          closeStatusModal();
          setIsLoading(false);
          return;
        }
        setIsLoading(false); // Reset loading state
        toast.success("Status updated successfully!");
        handleStatusUpdate(); // Call the function to handle status update
        closeStatusModal();
        refetch();
        refetchAuditTrail();
        refetchAuditTrailData();
        refetchAuditTrailForwardedData();
      } else if (response.error) {
        // Extract error details from the response
        const { status, data }: any = response.error;

        if (data?.detail) {
          // Show detailed error messages dynamically
          if (Array.isArray(data.detail)) {
            data.detail.forEach((message: any) => {
              toast.error(` ${message}`); // Display each error message
            });
          } else if (typeof data.detail === "string") {
            toast.error(data.detail); // Display the string error message
          }
        } else if (data?.status_type) {
          data?.status_type.forEach((message) => {
            toast.error(` ${message}`); // Display each error message
          });

        } else {
          console.log(data)
          toast.error(
            `Error ${status}: Something went wrong. Please try again.`
          );
        }

        setIsLoading(false); // Reset loading state
      }
    } catch (error) {
      setIsLoading(false); // Reset loading state
      console.error(error); // Log the error
    }
    closeStatusModal();
  };

  const handleFileChange = async (event) => {
    const newFiles = Array.from(event.target.files);
    const filePromises = newFiles.map((file: any) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const fileData = {
            file_name: file.name,
            file: e.target.result.split(",")[1], // Extracting Base64 part
          };
          resolve(fileData);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });

    try {

      const fileDataArray = await Promise.all(filePromises);
      setFiles((prevFiles) => {
        return [...prevFiles, ...fileDataArray];
      });
    } catch (error) {
      toast.error("An error occurred while uploading files. Please try again.");
    }
  };

  const handleSaveInternlaNotes = async () => {
    if (value.trim().length === 0) {
      toast.warning("Please add internal note before saving.");
      return;
    }

    setSavingLoading(true);
    const internalNoteObj = {
      attachments: files,
      content: value,
      ticket: storingTicketId ? storingTicketId : `${uuid}`,
    };
    try {
      await trigger(internalNoteObj).unwrap();
      setInitialShow(true);
    } catch (error) {
      toast.error("Failed to save note.");
    } finally {
      setSavingLoading(false);
    }
  };
  const isNoteEmpty = value.trim().length === 0;

  const shouldBlockSave = () => {
    const isResolved = selectedAllStatus?.status === "Resolved";
    return isResolved && isNoteEmpty;
  };

  // const handleSaveExternalNotes = async () => {
  // setSavingLoading(true);
  // const ticketId = storingTicketId ?? uuid!;
  // const isResolved = selectedAllStatus?.status === "Resolved";

  // //  Mandatory internal note check for Resolved status
  // // if (isResolved && value.trim().length === 0) {
  // //   toast.warning("Please add internal note before saving.");
  // //   setSavingLoading(false);
  // //   return;
  // // }
  // if (shouldBlockSave()) {
  // toast.warning("Please add internal note before saving.");
  // setSavingLoading(false);
  // return;
  // }
  // const externalNoteObj = {
  // attachments: files,
  // content: value,
  // ticket: storingTicketId ? storingTicketId : `${uuid}`,
  // template: "",
  // };

  // try {
  // const response = await axios.post(
  // `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/tickets/customer-note/`,
  // externalNoteObj,
  // {
  // headers: {
  // Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
  // },
  // }
  // );

  // if (response.data) {
  // // SMTP is configured → close modal and show confirmation
  // setInitialShow(true); // triggers confirmation popup
  // //  closeStatusModal();
  // }
  // } catch (error) {
  // const detail = error?.response?.data?.detail;
  // const smtpError =
  // Array.isArray(detail?.["server-configuration"]) &&
  // detail["server-configuration"].includes(
  // "smtp server configuration not found for this team"
  // );

  // const unauthorizedNoteError =
  // typeof detail === "string" &&
  // detail === "You are not authorized to send customer notes";

  // if (smtpError) {
  // if (shouldBlockSave()) {
  // toast.warning("Please add internal note before saving.");
  // } else {
  // toast.error("SMTP configuration is missing for this team.");
  // setInitialShow(true); // Only show confirmation if note is valid
  // closeStatusModal(); // Only close if note is valid
  // } //Still show confirmation popup
  // } else if (unauthorizedNoteError) {
  // toast.error("You are not authorized to send customer notes.");
  // closeStatusModal();
  // } else {
  // toast.error("Failed to save external note.");
  // }

  // console.error("External note save failed:", error.response?.data);
  // } finally {
  // setSavingLoading(false);
  // }
  // };



  // const handleResolveInternlaNotes = async () => {
  // setSavingLoading(true);
  // const ticketId = storingTicketId ?? uuid!;
  // const isResolved = selectedAllStatus?.status === "Resolved";

  // //  if (value.trim().length === 0) {
  // //     toast.warning("Please add internal note before saving.");
  // //     setSavingLoading(false);
  // //     return;
  // //   }
  // if (shouldBlockSave()) {
  // toast.warning("Please add internal note before saving.");
  // setSavingLoading(false);
  // return;
  // }

  // const internalNoteObj = {
  // attachments: files,
  // content: value,
  // ticket: storingTicketId ? storingTicketId : `${uuid}`,

  // };

  // try {
  // const result = await trigger(internalNoteObj).unwrap();
  // setInitialShow(true);
  // } catch (error) {
  // toast.error("Failed to save note.");
  // } finally {
  // setSavingLoading(false);
  // }
  // };



  const handleResolveInternlaNotes = async () => {
    setSavingLoading(true);

    if (shouldBlockSave()) {
      toast.warning("Please add internal note before saving.");
      setSavingLoading(false);
      return;
    }

    try {
      await trigger({
        attachments: files,
        content: value,
        ticket: storingTicketId ? storingTicketId : `${uuid}`,
      }).unwrap();

      setInternalNoteSavedOnce(true); // ✅ Mark internal note saved
      setInternalDraft({ value, files }); // ✅ Save internal draft

      if (showExternalNotes && !externalNoteSavedOnce) {
        toast.warning("Please add external note.");

        // ✅ Clear note content and attachments before switching
        setValue("");
        setFiles([]);

        // ✅ Flag for RadioGroup to know this is an auto-switch
        setAutoSwitchToExternal(true);
        setNoteType("external");

        return;
      }

      setInitialShow(true); // ✅ Show confirmation only if both notes are saved
    } catch (error) {
      toast.error("Failed to save note.");
    } finally {
      setSavingLoading(false);
    }
  };


  const handleSaveExternalNotes = async () => {
    setSavingLoading(true);
    if (!internalNoteSavedOnce) {
      toast.warning("Please save internal note first.");
      setNoteType("internal");
      setSavingLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/tickets/customer-note/`,
        {
          attachments: files,
          content: value,
          ticket: storingTicketId ? storingTicketId : `${uuid}`,
          template: "",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
          },
        }
      );

      if (response.data) {
        setExternalNoteSavedOnce(true); // ✅ Mark external note saved

        if (internalNoteSavedOnce) {
          setInitialShow(true); // ✅ Show confirmation only if both notes are saved
        }
      }
    } catch (error) {
      const detail = error?.response?.data?.detail;
      const smtpError =
        Array.isArray(detail?.["server-configuration"]) &&
        detail["server-configuration"].includes("smtp server configuration not found for this team");

      const unauthorizedNoteError =
        typeof detail === "string" && detail === "You are not authorized to send customer notes";

      if (smtpError) {
        toast.error("Email not configured for this team.");
        setInitialShow(true);
      } else if (unauthorizedNoteError) {
        toast.error("You are not authorized to send customer notes.");
        setInitialShow(true);

      } else if (detail?.length > 0) {


        toast.error(detail[0]);


      } else {

        toast.error("Failed to save external note.");
      }

      console.error("External note save failed:", error.response?.data);
    } finally {
      setSavingLoading(false);
    }
  };


  useEffect(() => {
    if (error) {
      console.log("error", error)
    }

  }, [error])
  const handleDeleteFile = (fileToDelete) => () => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToDelete));
  };

  console.log(files, "file");
  console.log(value, "fileValue");
  const tenantName = localStorage.getItem("circleone-user")?.toLowerCase(); // normalize casing
  const showExternalNotes =
    selectedAllStatus?.status === "Resolved" &&
    ["stage", "payswiff", "meta", "payswifftest", "globtier2"].includes(tenantName);

  // Drafts for each type
  const [internalDraft, setInternalDraft] = useState({ value: "", files: [] });
  const [externalDraft, setExternalDraft] = useState({ value: "", files: [] });

  return (
    <div className="card-body">
      {!initialsShow ? (
        <>
          {showExternalNotes ? (
            <>
              <FormControl component="fieldset" sx={{ mb: 2 }}>
                {/* <FormLabel component="legend" className="fs-6 fw-semibold">
Select note type
</FormLabel> */}
                {/* <RadioGroup
row
name="note-type"
value={noteType}
onChange={(e) => setNoteType(e.target.value as "internal" | "external")}
> */}
                <RadioGroup
                  row
                  name="note-type"
                  value={noteType}
                  // onChange={(e) => {
                  // const selectedType = e.target.value as "internal" | "external";

                  // // Only clear if switching to a different type
                  // if (selectedType !== noteType) {
                  // setValue(""); // Clear note content
                  // setFiles([]); // Clear attachments
                  // }

                  // setNoteType(selectedType); // Update selection
                  // }}
                  // onChange={(e) => {
                  //   const selectedType = e.target.value as "internal" | "external";

                  //   // Save current draft
                  //   if (noteType === "internal") {
                  //     setInternalDraft({ value, files });
                  //   } else {
                  //     setExternalDraft({ value, files });
                  //   }

                  //   // Restore new draft
                  //   if (selectedType === "internal") {
                  //     setValue(internalDraft.value);
                  //     setFiles(internalDraft.files);
                  //   } else {
                  //     setValue(externalDraft.value);
                  //     setFiles(externalDraft.files);
                  //   }

                  //   setNoteType(selectedType);
                  // }}
                  onChange={(e) => {
                    const selectedType = e.target.value as "internal" | "external";

                    // Save current draft
                    if (noteType === "internal") {
                      setInternalDraft({ value, files });
                    } else {
                      setExternalDraft({ value, files });
                    }

                    // Restore or clear
                    if (selectedType === "internal") {
                      setValue(internalDraft.value);
                      setFiles(internalDraft.files);
                    } else {
                      if (autoSwitchToExternal) {
                        setValue(""); // ✅ Clear external note
                        setFiles([]);
                        setAutoSwitchToExternal(false); // ✅ Reset flag
                      } else {
                        setValue(externalDraft.value);
                        setFiles(externalDraft.files);
                      }
                    }

                    setNoteType(selectedType);
                  }}

                >
                  <FormControlLabel value="internal" control={<Radio />} label="Internal Note" />
                  <FormControlLabel value="external" control={<Radio />} label="External Note" />
                </RadioGroup>
              </FormControl>

              {noteType === "internal" ? (
                <>
                  <label className="fs-5 fw-bold"></label>
                  <textarea
                    className="form-control form-control-lg form-control-solid mb-2 mt-2"
                    name="account_name"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    rows={4}
                    placeholder="Enter internal notes here"
                  />
                </>
              ) : (
                <>
                  <label className="fs-5 fw-bold"></label>
                  <textarea
                    className="form-control form-control-lg form-control-solid mb-2 mt-2"
                    name="account_name1"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    rows={4}
                    placeholder="Enter external notes here"
                  />
                </>
              )}

              {files.length > 0 && (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
                  {files.map((file, index) => (
                    <Chip key={index} label={file.file_name} onDelete={handleDeleteFile(file)} />
                  ))}
                </Box>
              )}

              <div className="d-flex justify-content-end">
                <Button
                  component="label"
                  className={`btn btn-active-light-primary btn-icon ${value ? "" : "disabled"}`}
                  title="You can add attachments for the following file types: xls,pdf,csv,doc,jpg,png up to a maximum size of 15MB"
                >
                  <i className="bi bi-paperclip align-self-center text-dark fs-2 mx-2 "></i>
                  <input type="file" hidden multiple onChange={handleFileChange} disabled={!value} />
                </Button>
              </div>

              <div className="d-flex justify-content-end mt-10">
                {/* <button type="reset" className="btn btn-sm btn-white me-3" onClick={closeStatusModal} disabled={savingLoading}>
Cancel
</button> */}

                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  onClick={noteType === "internal" ? handleResolveInternlaNotes : handleSaveExternalNotes}
                  disabled={savingLoading}
                >
                  {savingLoading ? "Saving..." : "Save"}
                </button>
              </div>
            </>
          ) : (
            <>
              <label className="fs-5 fw-bold">
                Internal Notes <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                className="form-control form-control-lg form-control-solid mb-2 mt-2"
                name="account_name"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                rows={4}
                placeholder="Enter internal notes here"
                required
              />
              {files.length > 0 && (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
                  {files.map((file, index) => (
                    <Chip key={index} label={file.file_name} onDelete={handleDeleteFile(file)} />
                  ))}
                </Box>
              )}

              <div className="d-flex justify-content-end">
                <Button
                  component="label"
                  className={`btn btn-active-light-primary btn-icon ${value ? "" : "disabled"}`}
                  title="You can add attachments for the following file types: xls,pdf,csv,doc,jpg,png up to a maximum size of 15MB"
                >
                  <i className="bi bi-paperclip align-self-center text-dark fs-2 mx-2 "></i>
                  <input type="file" hidden multiple onChange={handleFileChange} disabled={!value} />
                </Button>
              </div>

              <div className="d-flex justify-content-end mt-10">
                <button type="reset" className="btn btn-sm btn-white me-3" onClick={closeStatusModal} disabled={savingLoading}>
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  onClick={handleSaveInternlaNotes}
                  disabled={savingLoading || value.trim().length === 0}
                >
                  {savingLoading ? "Saving..." : "Save"}
                </button>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <span className="fs-5 fw-bold">Are you sure you want to change the status?</span>
          <div className="d-flex justify-content-end mt-10">
            <button type="reset" className="btn btn-sm btn-white me-3" onClick={closeStatusModal} disabled={isLoading}>
              Cancel
            </button>

            <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? "Updating..." : "Update"}
            </button>
          </div>
        </>
      )}
    </div>
  );

};

export default ChangeStatusModal;



